var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"draft-app-icon"},[_c('header',{staticClass:"draft-app-icon__name"},[_vm._v("\n    "+_vm._s(_vm.$t('APPS.DRAFT.STEPS.APP_MEDIA.APP_ICON'))+"\n  ")]),_vm._v(" "),_c('img',{staticClass:"draft-app-icon__icon",attrs:{"src":_vm.draftApp.icon,"alt":_vm.draftApp.name}})])
}
var staticRenderFns = []

export { render, staticRenderFns }